const undefinedTypeString = "undefined";

export enum AppModeEnum {
    webAddIn,
    contentManager
}

export class GeneralModule {
    private AppMode: AppModeEnum = AppModeEnum.webAddIn;
    private isFileInfoPanelOpen = false;
    private openUploadPanel = false;
    private isMultiMetaFileUpdatePanelOpen = false;
    private preExpandTeamId: string | null = null;

    getIsOfficeJSAvailable() {
        return typeof Office !== undefinedTypeString
            && (typeof Office.context?.diagnostics?.host !== undefinedTypeString
                || typeof Office.context?.mailbox?.diagnostics?.hostName !== undefinedTypeString);
    }

    setAppMode(appMode: AppModeEnum) {
        this.AppMode = appMode;
    }

    getAppMode() {
        return this.AppMode;
    }

    isInConentMangerMode() {
        return this.AppMode === AppModeEnum.contentManager;
    }

    setIsFileInfoPanelOpen(isOpen: boolean) {
        this.isFileInfoPanelOpen = isOpen;
    }

    getIsFileInfoPanelOpen() {
        return this.isFileInfoPanelOpen;
    }

    setIsMultiMetaFileUpdatePanelOpen(isOpen: boolean) {
        this.isMultiMetaFileUpdatePanelOpen = isOpen;
    }

    getIsMultiMetaFileUpdatePanelOpen() {
        return this.isMultiMetaFileUpdatePanelOpen;
    }

    setOpenPanelUploadPanel(isOpen: boolean) {
        this.openUploadPanel = isOpen;
    }

    getOpenPanelUploadPanel() {
        return this.openUploadPanel;
    }

    setPreExpandTeamId(teamId: string | null) {
        this.preExpandTeamId = teamId;
    }

    getPreExpandTeamId() {
        return this.preExpandTeamId;
    }
}

const generalModule = new GeneralModule();
export default generalModule;